import Robot from 'app/src/engine/movable-items/Robot';

export default class BetaRobot extends Robot {
	public clone(): BetaRobot {
		const clone = new BetaRobot(this._id);
		clone.alive = this.alive;
		return clone;
	}
}
